import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { styled } from "@mui/material/styles";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import AdDialog from "@modals/AdDialog";
import { Typography } from "@mui/material";
import { useAdvertisement } from "@redux/advertisement";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import CheckIcon from "@mui/icons-material/Check";
import dayjs from "dayjs";
import { textCut } from "@assets/utils/check";
import ClearIcon from "@mui/icons-material/Clear";
import Chip from "@mui/material/Chip";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import _ from "lodash";
import { useMenuDispatch } from "@assets/contexts/MenuContext";
import { etcMap, etcfilterResult } from "@assets/utils/check";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.grey[400],
    color: theme.palette.grey[800],
    borderBottom: 0,
    paddingTop: 28,
    paddingBottom: 28,
  },
  [`&.${tableCellClasses.head}:first-of-type`]: {
    borderTopLeftRadius: "15px",
    borderBottomLeftRadius: "15px",
  },
  [`&.${tableCellClasses.head}:last-of-type`]: {
    borderTopRightRadius: "15px",
    borderBottomRightRadius: "15px",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    paddingTop: 35,
    paddingBottom: 35,
    borderColor: "#FAFAFB",
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  cursor: "pointer",
  "&:last-child td, &:last-child th": {
    border: 0,
  },
  "&:hover": {
    backgroundColor: "#EDF7FE",
  },
}));

const label = { inputProps: { "aria-label": "Checkbox demo" } }; // 전체기간 라벨

const CompAdCurrent = () => {
  const value = useMenuDispatch(); // function  context
  const advertisement = useAdvertisement();
  const [open, setOpen] = useState(false);
  const [target, setTarget] = useState(null);
  const [loading, setLoading] = useState(true);
  const [aSort, setASort] = useState({
    recent: true,
    adv: null, // ad 총 리스트 정렬
    adv_default: null, // ad 총 리스트 정렬
    advertiser: [], // 광고주/대행사
    advertiser_default: [], // 광고주 대행사 토탈값
    ad: [], // 광고상품
    is_cpm: ["Y", "N"], //유형
    type: [1, 2, 3, 4, 5, 6, 7, 8, 9, 13, 14, 15], //소개
    live: ["Y", "N"], //상태
    rows: null, // 필터 row
    rows_default: null, // 모든 리스트 row
    page: 1,
  });
  const [refreshTime, setRefreshTime] = useState(Date.now());
  const navigate = useNavigate();
  // 광고현황 Left 메뉴 광고주 삭제 및 추가
  const handleChecked = (e, num) => {
    const checkedCheck = e.target.checked;

    if (num === 0) {
      if (checkedCheck) {
        const newRows = aSort.rows_default.filter((data) => {
          return (
            aSort.is_cpm.findIndex((e) => e === data.is_cpm) !== -1 &&
            aSort.type.findIndex((e) => e === data.ad_type) !== -1 &&
            aSort.live.findIndex((e) => e === data.live) !== -1
          );
        });
        setASort({
          ...aSort,
          adv: aSort.adv_default,
          advertiser: aSort.advertiser_default,
          rows: aSort.recent ? sortDate1(newRows) : sortDate2(newRows),
          page: 1,
        });
      } else {
        setASort({
          ...aSort,
          adv: [],
          advertiser: [],
          rows: [],
          page: 1,
        });
      }
    } else {
      const newAdvertiser = checkedCheck
        ? [...aSort.advertiser, num]
        : aSort.advertiser.filter((data) => data !== num);

      const newRows = aSort.rows_default.filter((data) => {
        return (
          aSort.is_cpm.findIndex((e) => e === data.is_cpm) !== -1 &&
          aSort.type.findIndex((e) => e === data.ad_type) !== -1 &&
          aSort.live.findIndex((e) => e === data.live) !== -1 &&
          newAdvertiser.findIndex((e) => e === data.advertiser_id) !== -1
        );
      });

      setASort({
        ...aSort,
        adv: checkedCheck
          ? [...aSort.adv, ...aSort.adv_default.filter((data) => data[0].advertiser_id === num)]
          : aSort.adv.filter((data) => data[0].advertiser_id !== num),
        advertiser: newAdvertiser,
        rows: aSort.recent ? sortDate1(newRows) : sortDate2(newRows),
        page: 1,
      });
    }
  };

  const handleADChecked = (e) => {
    alert("광고상품 전체만 선택가능합니다.");
  };

  // 광고현황 광고유형 추가 및 삭제
  const handleCPMChecked = (e, is_cpm = "Y") => {
    const checkedCheck = e.target.checked;
    const newIsCpm = checkedCheck
      ? [...aSort.is_cpm, is_cpm]
      : aSort.is_cpm.filter((data) => data !== is_cpm);

    const newRows = aSort.rows_default.filter((data) => {
      return (
        newIsCpm.findIndex((e) => e === data.is_cpm) !== -1 &&
        aSort.type.findIndex((e) => e === data.ad_type) !== -1 &&
        aSort.live.findIndex((e) => e === data.live) !== -1 &&
        aSort.advertiser.findIndex((e) => e === data.advertiser_id) !== -1
      );
    });

    setASort({
      ...aSort,
      is_cpm: newIsCpm,
      rows: aSort.recent ? sortDate1(newRows) : sortDate2(newRows),
      page: 1,
    });
  };
  // 광고현황 소재 추가 및 삭제
  const handleTypeChecked = (e, type = 1) => {
    const checkedCheck = e.target.checked;
    const newType = checkedCheck
      ? [...aSort.type, type]
      : aSort.type.filter((data) => data !== type);

    const newRows = aSort.rows_default.filter((data) => {
      return (
        newType.findIndex((e) => e === data.ad_type) !== -1 &&
        aSort.is_cpm.findIndex((e) => e === data.is_cpm) !== -1 &&
        aSort.live.findIndex((e) => e === data.live) !== -1 &&
        aSort.advertiser.findIndex((e) => e === data.advertiser_id) !== -1
      );
    });

    setASort({
      ...aSort,
      type: newType,
      rows: aSort.recent ? sortDate1(newRows) : sortDate2(newRows),
      page: 1,
    });
  };

  // 광고현황 소재 추가 및 삭제
  const handleLiveChecked = (e, live = "Y") => {
    const checkedCheck = e.target.checked;
    const newLive = checkedCheck
      ? [...aSort.live, live]
      : aSort.live.filter((data) => data !== live);

    const newRows = aSort.rows_default.filter((data) => {
      return (
        newLive.findIndex((e) => e === data.live) !== -1 &&
        aSort.is_cpm.findIndex((e) => e === data.is_cpm) !== -1 &&
        aSort.type.findIndex((e) => e === data.ad_type) !== -1 &&
        aSort.advertiser.findIndex((e) => e === data.advertiser_id) !== -1
      );
    });

    setASort({
      ...aSort,
      live: newLive,
      rows: aSort.recent ? sortDate1(newRows) : sortDate2(newRows),
      page: 1,
    });
  };

  // 광고현황 Right 메뉴 광고주 삭제
  const handleDelete = (num = 0) => {
    setASort({
      ...aSort,
      adv: aSort.adv.filter((data) => {
        return data[0].advertiser_id !== num;
      }),
      advertiser: aSort.advertiser.filter((data) => {
        return data !== num;
      }),
      rows: aSort.rows.filter((data) => {
        return data.advertiser_id !== num;
      }),
      page: 1,
    });
  };

  const handleIsCpmDelete = (d = "Y") => {
    setASort({
      ...aSort,
      is_cpm: aSort.is_cpm.filter((data) => {
        return data !== d;
      }),
      rows: aSort.rows.filter((data) => {
        return data.is_cpm !== d;
      }),
      page: 1,
    });
  };

  const handleLiveDelete = (d = "Y") => {
    setASort({
      ...aSort,
      live: aSort.live.filter((data) => {
        return data !== d;
      }),
      rows: aSort.rows.filter((data) => {
        return data.live !== d;
      }),
      page: 1,
    });
  };

  const handleTypeDelete = (d = 1) => {
    setASort({
      ...aSort,
      type: aSort.type.filter((data) => {
        return data !== d;
      }),
      rows: aSort.rows.filter((data) => {
        return data.ad_type !== d;
      }),
      page: 1,
    });
  };

  const rowChecker = (rows = null) => {
    let num = 0;
    if (
      rows === null ||
      rows === undefined ||
      rows === "" ||
      rows.length === 0
    ) {
      num = 1;
    } else {
      num = Math.ceil(rows.length / 10);
    }
    return num;
  };
  const onNewRows = (newTarget) => {
    const newRpws = aSort.rows.map((d, i) => {
      return d.ad_id === newTarget.ad_id ? newTarget : d;
    });
    setASort({
      ...aSort,
      rows: newRpws,
    });
    setOpen(false);
  };
  const onNewRowsFilter = (ad_id) => {
    const newRpws = aSort.rows.filter((d, i) => {
      return d.ad_id !== ad_id;
    });
    setASort({
      ...aSort,
      rows: newRpws,
    });
  };
  // 내림차순 (시작일 최신순, 동일 시 ad_id 내림차순)
  const sortDate1 = (rows) => {
    return [...rows].sort(function (a, b) {
      const dateDiff =
        new Date(b.view_date_start).getTime() -
        new Date(a.view_date_start).getTime();
      return dateDiff !== 0 ? dateDiff : b.ad_id - a.ad_id;
    });
  };
  // 오름차순 (시작일 오래된순, 동일 시 ad_id 내림차순)
  const sortDate2 = (rows) => {
    return [...rows].sort(function (a, b) {
      const dateDiff =
        new Date(a.view_date_start).getTime() -
        new Date(b.view_date_start).getTime();
      return dateDiff !== 0 ? dateDiff : b.ad_id - a.ad_id;
    });
  };

  const pagenationList = (rows, page) => {
    let pageStart = (page - 1) * 10;
    let pageEnd = page * 10;
    const filterView = rows.filter(
      (row, index) => pageStart <= index && index < pageEnd
    );
    return filterView;
  };

  const handleChange = (event, value) => {
    setASort({ ...aSort, page: value });
  };

  const handleOpenForm = (ad_id) => {
    setOpen(true);

    advertisement.info(ad_id, (data, response) => {
      setTarget(data.result);
    });
  };

  const handleFilterRecentChange = (bol) => {
    setASort({
      ...aSort,
      recent: bol,
      rows: bol ? sortDate1(aSort.rows) : sortDate2(aSort.rows),
      page: 1,
    });
  };

  const handleClose = () => setOpen(false);

  const handleADDelete = (ad_id) => {
    // console.log(ad_id);
    if (window.confirm("정말로 삭제 하시겠습니까?")) {
      advertisement.delete(ad_id, (data, response) => {
        if(response?.data?.result) {
          setOpen(false);
          alert("삭제되었습니다.");
          setTimeout(() => setRefreshTime(Date.now()), 200);
        } else {
          alert("삭제에 실패하였습니다.");
        }
      });
      // window.open("exit.html", "Thanks for Visiting!");
    }
  };

  useEffect(() => {
    value({ type: "loadingStart" });
    advertisement.list((data, response) => {
      if (response.status === 200 && data.error === undefined) {
        const filterArr = data.result.filter(
          (d) => d.ad_type === 1 || d.ad_type === 2 || d.ad_type === 3 || d.ad_type === 4 || d.ad_type === 5 || d.ad_type === 6 || d.ad_type === 7 || d.ad_type === 8 || d.ad_type === 9 || d.ad_type === 13 || d.ad_type === 14 || d.ad_type === 15
        );
        const dateArray = _.uniq(
          filterArr.map((d, i) => {
            return d.advertiser_id;
          })
        );
        const newData = dateArray.map((d, i) => {
          return filterArr.filter((dd, ii) => {
            return dd.advertiser_id === d;
          });
        });
        setASort({
          ...aSort,
          adv: newData,
          adv_default: newData,
          advertiser: dateArray,
          advertiser_default: dateArray,
          rows: sortDate1([...filterArr]),
          rows_default: filterArr,
        });
        value({ type: "loadingEnd" });
      } else {
        value({ type: "loadingEnd" });
      }
      setLoading(false);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refreshTime]);

  return (
    <>
      {loading ? (
        <></>
      ) : (
        <>
          <Grid container direction="column">
            <Typography
              textAlign="left"
              variant="h1"
              component="div"
              fontWeight={500}
              sx={{ mb: 3 }}
            >
              광고현황
            </Typography>
          </Grid>
          <Grid
            container
            justifyContent="center"
            alignItems="center"
            sx={{ mb: 8 }}
          >
            <Box sx={{ flex: 1, pr: 2 }}>
              <Grid container direction="column">
                <Grid
                  container
                  justifyContent="space-between"
                  alignItems="center"
                  sx={{
                    backgroundColor: "grey.800",
                    height: "80px",
                    borderRadius: "10px",
                  }}
                >
                  <Typography
                    variant="h3"
                    color="white"
                    align="center"
                    fontWeight={"500"}
                    sx={{ width: "20%" }}
                  >
                    광고주/대행사
                  </Typography>
                  <Typography
                    variant="h3"
                    color="white"
                    align="center"
                    fontWeight={"500"}
                    sx={{ width: "20%" }}
                  >
                    캠페인명
                  </Typography>
                  <Typography
                    variant="h3"
                    color="white"
                    align="center"
                    fontWeight={"500"}
                    sx={{ width: "20%" }}
                  >
                    유형
                  </Typography>
                  <Typography
                    variant="h3"
                    color="white"
                    align="center"
                    fontWeight={"500"}
                    sx={{ width: "20%" }}
                  >
                    광고상품
                  </Typography>
                  <Typography
                    variant="h3"
                    color="white"
                    align="center"
                    fontWeight={"500"}
                    sx={{ width: "20%" }}
                  >
                    상태
                  </Typography>
                </Grid>
              </Grid>
              <Grid
                container
                justifyContent="space-around"
                direction="row"
                sx={{
                  backgroundColor: "white",
                  borderRadius: "10px",
                  height: 306,
                  mt: 1.25,
                }}
              >
                <Grid
                  container
                  direction="row"
                  sx={{
                    width: "20%",
                    height: "100%",
                    pt: 3.75,
                    pb: 3,
                    overflow: "auto",
                  }}
                >
                  <Grid
                    sx={{
                      width: "100%",
                      height: "100%",
                      pl: 3.75,
                      pr: 1,
                    }}
                  >
                    <FormControlLabel
                      sx={{ pb: 2, width: "100%" }}
                      control={
                        <Checkbox
                          {...label}
                          checked={
                            aSort.advertiser.length ===
                            aSort.advertiser_default.length
                              ? true
                              : false
                          }
                          onChange={(e) => handleChecked(e, 0)}
                          sx={{
                            p: 0,
                            "& .MuiSvgIcon-root": { fontSize: 22 },
                          }}
                        />
                      }
                      label={
                        <Typography
                          textAlign="center"
                          variant="body2"
                          component="div"
                          fontWeight={400}
                          sx={{ pl: 1 }}
                        >
                          광고주 전체
                        </Typography>
                      }
                    />

                    {aSort.adv_default &&
                      aSort.adv_default.map((data, i) => {
                        return (
                          <FormControlLabel
                            key={data[0].advertiser_id}
                            sx={{ pb: 2, width: "100%" }}
                            control={
                              <Checkbox
                                {...label}
                                checked={
                                  aSort.advertiser.findIndex(
                                    (e) => e === data[0].advertiser_id
                                  ) === -1
                                    ? false
                                    : true
                                }
                                onChange={(e) =>
                                  handleChecked(e, data[0].advertiser_id)
                                }
                                sx={{
                                  p: 0,
                                  "& .MuiSvgIcon-root": { fontSize: 22 },
                                }}
                              />
                            }
                            label={
                              <Typography
                                textAlign="center"
                                variant="body2"
                                component="div"
                                fontWeight={400}
                                sx={{ pl: 1 }}
                              >
                                {textCut(data[0].advertiser_name, 10)}
                              </Typography>
                            }
                          />
                        );
                      })}
                  </Grid>
                </Grid>
                <Grid
                  container
                  direction="row"
                  sx={{
                    width: "20%",
                    height: "100%",
                    pt: 3.75,
                    pb: 3,
                    borderLeft: "1px solid #EEEEEF",
                  }}
                >
                  <Grid
                    container
                    direction="column"
                    alignItems="flex-start"
                    sx={{
                      height: "100%",
                      pl: 3.75,
                      pr: 1,
                    }}
                  >
                    <FormControlLabel
                      sx={{ pb: 2, width: "100%" }}
                      control={
                        <Checkbox
                          {...label}
                          checked={true}
                          onChange={(e) => handleADChecked(e)}
                          sx={{
                            p: 0,
                            "& .MuiSvgIcon-root": { fontSize: 22 },
                          }}
                        />
                      }
                      label={
                        <Typography
                          textAlign="center"
                          variant="body2"
                          component="div"
                          fontWeight={400}
                          sx={{ pl: 1 }}
                        >
                          광고상품 전체
                        </Typography>
                      }
                    />
                  </Grid>
                </Grid>
                <Grid
                  container
                  direction="row"
                  sx={{
                    width: "20%",
                    height: "100%",
                    pt: 3.75,
                    pb: 3,
                    borderLeft: "1px solid #EEEEEF",
                    // overflow: "scroll",
                  }}
                >
                  <Grid
                    container
                    direction="column"
                    alignItems="flex-start"
                    sx={{
                      width: "100%",
                      height: "100%",
                      pl: 3.75,
                      pr: 1,
                    }}
                  >
                    <FormControlLabel
                      sx={{ pb: 2, width: "100%" }}
                      control={
                        <Checkbox
                          {...label}
                          checked={
                            aSort.is_cpm.findIndex((e) => e === "N") === -1
                              ? false
                              : true
                          }
                          onChange={(e) => handleCPMChecked(e, "N")}
                          sx={{
                            p: 0,
                            "& .MuiSvgIcon-root": { fontSize: 22 },
                          }}
                        />
                      }
                      label={
                        <Typography
                          textAlign="center"
                          variant="body2"
                          component="div"
                          fontWeight={400}
                          sx={{ pl: 1 }}
                        >
                          CPP
                        </Typography>
                      }
                    />
                    <FormControlLabel
                      sx={{ pb: 2, width: "100%" }}
                      control={
                        <Checkbox
                          {...label}
                          checked={
                            aSort.is_cpm.findIndex((e) => e === "Y") === -1
                              ? false
                              : true
                          }
                          onChange={(e) => handleCPMChecked(e, "Y")}
                          sx={{
                            p: 0,
                            "& .MuiSvgIcon-root": { fontSize: 22 },
                          }}
                        />
                      }
                      label={
                        <Typography
                          textAlign="center"
                          variant="body2"
                          component="div"
                          fontWeight={400}
                          sx={{ pl: 1 }}
                        >
                          CPM
                        </Typography>
                      }
                    />
                  </Grid>
                </Grid>
                <Grid
                  container
                  direction="row"
                  sx={{
                    width: "20%",
                    height: "100%",
                    pt: 3.75,
                    pb: 3,
                    borderLeft: "1px solid #EEEEEF",
                  }}
                >
                  <Grid
                    container
                    direction="column"
                    alignItems="flex-start"
                    sx={{
                      width: "100%",
                      height: "100%",
                      pl: 3.75,
                      pr: 1,
                    }}
                  >
                    {etcMap.map((etc) => (
                      <FormControlLabel
                        key={etc.index}
                        sx={{ pb: 2 }}
                        control={
                          <Checkbox
                            {...label}
                            checked={
                              aSort.type.findIndex((e) => e === etc.no) === -1
                                ? false
                                : true
                            }
                            onChange={(e) => handleTypeChecked(e, etc.no)}
                            sx={{
                              p: 0,
                              "& .MuiSvgIcon-root": { fontSize: 22 },
                            }}
                          />
                        }
                        label={
                          <Typography
                            textAlign="center"
                            variant="body2"
                            component="div"
                            fontWeight={400}
                            sx={{ pl: 1 }}
                          >
                            {etc.name}
                          </Typography>
                        }
                      />
                    ))}
                  </Grid>
                </Grid>
                <Grid
                  container
                  direction="row"
                  sx={{
                    width: "20%",
                    height: "100%",
                    pt: 3.75,
                    pb: 3,
                    borderLeft: "1px solid #EEEEEF",
                    overflow: "auto",
                  }}
                >
                  <Grid
                    container
                    direction="column"
                    alignItems="flex-start"
                    sx={{
                      width: "100%",
                      height: "100%",
                      overflow: "auto",
                      pl: 3.75,
                      pr: 1,
                    }}
                  >
                    <FormControlLabel
                      sx={{ pb: 2 }}
                      control={
                        <Checkbox
                          {...label}
                          checked={
                            aSort.live.findIndex((e) => e === "Y") === -1
                              ? false
                              : true
                          }
                          onChange={(e) => handleLiveChecked(e, "Y")}
                          sx={{
                            p: 0,
                            "& .MuiSvgIcon-root": { fontSize: 22 },
                          }}
                        />
                      }
                      label={
                        <Typography
                          textAlign="center"
                          variant="body2"
                          component="div"
                          fontWeight={400}
                          sx={{ pl: 1 }}
                        >
                          Y
                        </Typography>
                      }
                    />
                    <FormControlLabel
                      sx={{ pb: 2 }}
                      control={
                        <Checkbox
                          {...label}
                          checked={
                            aSort.live.findIndex((e) => e === "N") === -1
                              ? false
                              : true
                          }
                          onChange={(e) => handleLiveChecked(e, "N")}
                          sx={{
                            p: 0,
                            "& .MuiSvgIcon-root": { fontSize: 22 },
                          }}
                        />
                      }
                      label={
                        <Typography
                          textAlign="center"
                          variant="body2"
                          component="div"
                          fontWeight={400}
                          sx={{ pl: 1 }}
                        >
                          N
                        </Typography>
                      }
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Box>
            <Box
              sx={{
                width: 304,
                height: 400,
                backgroundColor: "grey.400",
                borderRadius: "10px",
                pt: 4.375,
                pb: 4.375,
                pl: 3.125,
                pr: 3.125,
              }}
            >
              <Grid container direction="column">
                <Typography variant="body2" color="grey.600">
                  광고주
                </Typography>
                <Grid sx={{ height: 85, mb: 1, overflow: "auto" }}>
                  <Typography variant="body2" component="div">
                    {(aSort.adv !== null ||
                      aSort.adv !== undefined ||
                      aSort.adv) &&
                      aSort.adv.map((data, index) => {
                        return (
                          <Typography
                            variant="body2"
                            component="span"
                            key={data[0].advertiser_id}
                          >
                            <Chip
                              variant="outlined"
                              size="small"
                              sx={{
                                "& .MuiChip-label": {
                                  pl: 0,
                                },
                              }}
                              deleteIcon={<ClearIcon />}
                              label={
                                <Typography variant="body2" component="span">
                                  {data[0].advertiser_id} /22
                                  {data[0].advertiser_name}
                                </Typography>
                              }
                              onDelete={() =>
                                handleDelete(data[0].advertiser_id)
                              }
                            />
                          </Typography>
                        );
                      })}
                  </Typography>
                </Grid>
                <Typography variant="body2" color="grey.600">
                  광고상품
                </Typography>
                <Grid sx={{ height: 85, mb: 1, overflow: "auto" }}>
                  <Typography variant="body2" component="span">
                    <Chip
                      variant="outlined"
                      size="small"
                      sx={{
                        "& .MuiChip-label": {
                          pl: 0,
                        },
                      }}
                      deleteIcon={<ClearIcon />}
                      label={
                        <Typography
                          variant="body2"
                          component="span"
                          sx={{ pl: 0 }}
                        >
                          광고상품 전체
                        </Typography>
                      }
                      onDelete={() => alert("광고상품 전체만 선택가능합니다.")}
                    />
                  </Typography>
                </Grid>
                <Typography variant="body2" color="grey.600">
                  광고상품 ∙ 유형 ∙ 상태
                </Typography>
                <Grid sx={{ height: 85, overflow: "auto" }}>
                  {aSort.is_cpm.length !== 0 &&
                    aSort.is_cpm.map((data, i) => {
                      return (
                        <Typography variant="body2" component="span" key={data}>
                          <Chip
                            variant="outlined"
                            size="small"
                            sx={{
                              "& .MuiChip-label": {
                                pl: 0,
                              },
                            }}
                            deleteIcon={<ClearIcon />}
                            label={
                              <Typography variant="body2" component="span">
                                {data === "Y" ? "CPM" : "CPP"}
                              </Typography>
                            }
                            onDelete={() => handleIsCpmDelete(data)}
                          />
                        </Typography>
                      );
                    })}
                  {aSort.type.length !== 0 &&
                    aSort.type.map((data) => {
                      return (
                        <Typography variant="body2" component="span" key={data}>
                          <Chip
                            variant="outlined"
                            size="small"
                            sx={{
                              "& .MuiChip-label": {
                                pl: 0,
                              },
                            }}
                            deleteIcon={<ClearIcon />}
                            label={
                              <Typography variant="body2" component="span">
                                {etcfilterResult(data)}
                              </Typography>
                            }
                            onDelete={() => handleTypeDelete(data)}
                          />
                        </Typography>
                      );
                    })}
                  {aSort.live.length !== 0 &&
                    aSort.live.map((data) => {
                      return (
                        <Typography variant="body2" component="span" key={data}>
                          <Chip
                            variant="outlined"
                            size="small"
                            sx={{
                              "& .MuiChip-label": {
                                pl: 0,
                              },
                            }}
                            deleteIcon={<ClearIcon />}
                            label={
                              <Typography variant="body2" component="span">
                                상태 {data}
                              </Typography>
                            }
                            onDelete={() => handleLiveDelete(data)}
                          />
                        </Typography>
                      );
                    })}
                </Grid>
              </Grid>
            </Box>
          </Grid>
          <Grid container justifyContent="flex-end" sx={{ mb: 2.5 }}>
            <Typography
              variant="body"
              component="div"
              color={aSort.recent ? "primary.main" : "grey.500"}
              onClick={() => handleFilterRecentChange(true)}
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                pr: 2.5,
                cursor: "pointer",
              }}
            >
              <CheckIcon sx={{ fontSize: 22 }} />
              &nbsp; (시작일)최신순
            </Typography>
            <Typography
              variant="body"
              component="div"
              color={!aSort.recent ? "primary.main" : "grey.500"}
              onClick={() => handleFilterRecentChange(false)}
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                pr: 2.5,
                cursor: "pointer",
              }}
            >
              <CheckIcon sx={{ fontSize: 22 }} />
              &nbsp; (시작일)오래된순
            </Typography>
          </Grid>
          <TableContainer sx={{ minHeight: 587 }}>
            <Table
              sx={{
                minWidth: 700,
                borderCollapse: "collapse",
              }}
              aria-label="customized table"
            >
              <TableHead>
                <TableRow>
                  <StyledTableCell align="center">
                    <Typography variant="body">광고주/대행사</Typography>
                  </StyledTableCell>
                  <StyledTableCell align="center">
                    <Typography variant="body">캠페인명</Typography>
                  </StyledTableCell>
                  <StyledTableCell align="center">
                    <Typography variant="body">광고상품</Typography>
                  </StyledTableCell>
                  <StyledTableCell align="center">
                    <Typography variant="body">시작일</Typography>
                  </StyledTableCell>
                  <StyledTableCell align="center">
                    <Typography variant="body">종료일</Typography>
                  </StyledTableCell>
                  <StyledTableCell align="center">
                    <Typography variant="body">상태</Typography>
                  </StyledTableCell>
                </TableRow>
              </TableHead>
              {aSort.rows !== null && (
                <TableBody
                  sx={{
                    "&::before": {
                      lineHeight: "3em",
                      content: `"."`,
                      color: "white",
                    },
                  }}
                >
                  {aSort.rows.length === 0 ? (
                    <tr>
                      <td colSpan="6">
                        <Grid
                          container
                          justifyContent="center"
                          alignItems="center"
                          direction="column"
                          sx={{
                            height: "600px",
                            borderRadius: "15px",
                            bgcolor: "white",
                          }}
                        >
                          <ErrorOutlineIcon
                            sx={{ fontSize: 36, color: "grey.600" }}
                          />
                          <Typography
                            variant="body"
                            color={"grey.600"}
                            sx={{ pt: 1 }}
                          >
                            광고주와 광고명을 선택해 주세요
                          </Typography>
                        </Grid>
                      </td>
                    </tr>
                  ) : (
                    <>
                      {pagenationList(aSort.rows, aSort.page).map((row, i) => (
                        <StyledTableRow
                          key={row.ad_id}
                          onClick={() => handleOpenForm(row.ad_id)}
                        >
                          <StyledTableCell
                            component="th"
                            scope="row"
                            align="center"
                          >
                            <Typography variant="body" fontWeight={400}>
                              {row.advertiser_name}
                            </Typography>
                          </StyledTableCell>
                          <StyledTableCell align="center">
                            <Typography variant="body" fontWeight={400}>
                              {textCut(row.title, 15)}
                            </Typography>
                          </StyledTableCell>
                          <StyledTableCell align="center">
                            {etcfilterResult(row.ad_type)}
                          </StyledTableCell>
                          <StyledTableCell align="center">
                            {dayjs(row.view_date_start).format(
                              "YY년 MM월 DD일 HH:mm:ss"
                            )}
                          </StyledTableCell>
                          <StyledTableCell align="center">
                            {dayjs(row.view_date_end).format(
                              "YY년 MM월 DD일 HH:mm:ss"
                            )}
                          </StyledTableCell>
                          <StyledTableCell align="center">
                            {row.live}
                          </StyledTableCell>
                        </StyledTableRow>
                      ))}
                    </>
                  )}
                </TableBody>
              )}
            </Table>
          </TableContainer>
          <Grid
            container
            justifyContent="center"
            alignItems="center"
            sx={{ pt: 4, pb: 4, mt: 2, mb: 2 }}
          >
            <Stack spacing={2}>
              <Pagination
                color="primary"
                count={rowChecker(aSort.rows)}
                page={aSort.page}
                onChange={handleChange}
              />
            </Stack>
          </Grid>
        </>
      )}
      {open && target !== null && (
        <AdDialog
          open={open}
          target={target}
          onClose={handleClose}
          onADDELETE={handleADDelete}
          onNewRows={onNewRows}
          onNewRowsFilter={onNewRowsFilter}
        />
      )}
    </>
  );
};

export default CompAdCurrent;
